import React, { useMemo } from 'react';
import { getMessage } from '@tcc/i18n';
import { Link } from '@tcc/crate';
import BetaTag from 'common/BetaTag';
import { SCRIPT_CREATOR_URL } from 'constants/urls';
import ScriptingCard from './ScriptingCard';
import ScriptingCardTrigger from './ScriptingCardTrigger';

const baseString = 'vra-field-level-seed-recs-card';

interface FieldLevelSeedRecsCardProps {
  disabled?: boolean;
}

const FieldLevelSeedRecsCard = ({ disabled }: FieldLevelSeedRecsCardProps) => {
  const baseButton = useMemo(() => (
    <ScriptingCardTrigger
      isPrimary={!disabled}
      isDisabled={disabled}
      triggerClassString="vra-scripting-card__trigger"
      testId="field-level-seed-recs-link-button"
      text={getMessage(disabled ? 'button-text__disabled--corn-only' : 'button-text__start' )}
    />
  ), [disabled]);

  const button = (
    <Link
      href={SCRIPT_CREATOR_URL.FIELD_LEVEL_SEED_RECS}
      data-test-id="field-level-seed-recs-link"
    >
      {baseButton}
    </Link>
  );

  return (
    <div className={`${baseString}__wrapper`}>
      <h2>{getMessage('text__static-rate')}</h2>
      <ScriptingCard
        button={disabled ? baseButton : button}
        optionType="manual"
        body={getMessage('text__field-level-seed-recs-prescriptions-intro')}
        title={
          <>
            {getMessage('text__field-level-seed-recs')}
            <BetaTag />
          </>
        }
      />
    </div>
  );
};

export default FieldLevelSeedRecsCard;
